<script setup>
    import ScoreAchievement from '@/components/result/ai-literacy-2026/ScoreAchievement.vue';  
    import AchievementTable from '@/components/result/ai-literacy-2026/AchievementTable.vue'; 

    const userRole = 'parent';
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">
            <ScoreAchievement />
            <AchievementTable :userRole="userRole" studentLevel="4" />     
        </div>
    </div>
</template>